import WebsitePlotExclusionCreate from './Create';

export default {
    create: WebsitePlotExclusionCreate,
};
